import meeting from './reducers';

export default meeting;
